import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";
import type User from "./User";

@Model()
class MediaReleaseTemplate extends ApplicationRecord {
  static jsonapiType = "media_release_templates";

  @Attr({ persist: false }) archivedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() message: string;

  @Attr() name: string;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() organisationTeamId: number;

  @Attr({ persist: false }) updatedAt: string;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default MediaReleaseTemplate;
